export function setLocalStorage({ key, value }: {key: string, value: any}) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function getLocalStorage({ key }: {key: string}): any {
  return JSON.parse(localStorage.getItem(key));
}
